import React, { Suspense } from "react";
import jwt_decode from "jwt-decode";
import { useEffect } from "react";
import { GetVendorDetails } from "../store/apiCalls/profilesetup";
import { LinkedInCallback } from 'react-linkedin-login-oauth2';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSkillsData } from "../store/apiCalls/profilesetup";
import { PATH } from "./path";
import {
  protectedRouteNavigators,
  publicRouteNavigators,
} from "./routeNavigator";
import { async } from "@firebase/util";

function ProtectedRoute(props) {
  const { isLoggedIn } = props;
  return isLoggedIn ? (
    <div className="main-container">
      <Outlet />
    </div>
  ) : (
    <Navigate to={PATH.LOGIN} />
  );
}

function PublicRoute(props) {
  const { isLoggedIn, isSetupProfile } = props;
  return isLoggedIn ? <Navigate to={isSetupProfile ? PATH.VENDORDASHBOARD : PATH.PROFILESETUP} /> : <Outlet />;
}

function CustumRoutes() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(
    (state) => state?.LoginReducer?.userLoginDetails?.token ?? null
  );
  
  const isSetupProfile = useSelector(
    (state) => state?.LoginReducer?.user?.isSetupProfile ?? null
  );

  if(isLoggedIn) {
    const { id } = isLoggedIn ? jwt_decode(isLoggedIn) : "";
    const params = { id: id };
    const header = { Authorization: `Bearer ${isLoggedIn}` };
    const fetchData = async () => {
      const resp = await GetVendorDetails(params, header).catch((error) => {
        return error
      });
      if(!resp.data?.data?._id) {
        localStorage.removeItem("vendorToken");
        dispatch({type: 'LOGOUT_STATUS_SUCCESS'})
      }
    }
    fetchData()
  }
  
  return (
    <BrowserRouter basename="/Sevahaat">
      <Suspense fallback={<h1>Loading...</h1>}>
        <Routes>
          <Route element={<PublicRoute isLoggedIn={isLoggedIn} isSetupProfile={isSetupProfile} />}>
            {publicRouteNavigators.map((prop) => {
              return (
                <Route
                  path={prop.path}
                  name={prop.name}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  element={<prop.PropComponent {...prop?.props} />}
                  key={prop.name}
                  exact
                />
              );
            })}
          </Route>
          <Route element={<ProtectedRoute isLoggedIn={isLoggedIn} isSetupProfile={isSetupProfile} />}>
            {protectedRouteNavigators.map((prop) => {
              return (
                <Route
                  path={prop.path}
                  name={prop.name}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  element={<prop.PropComponent {...prop?.props} />}
                  key={prop.name}
                  exact
                />
              );
            })}
          </Route>
          <Route exact path='/linkedin' element={<LinkedInCallback />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
export default CustumRoutes;
